var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompletion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 12.02,
    viewBox: "0 0 16 12.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_949",
    "data-name": "Rectangle 949",
    width: 16,
    height: 12.02,
    fill: "#60ac50"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6890",
    "data-name": "Group 6890",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6889",
    "data-name": "Group 6889",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4260",
    "data-name": "Path 4260",
    d: "M28.145,0a.762.762,0,0,0-.524.229L17.12,10.706A.762.762,0,1,0,18.2,11.783L28.7,1.306A.761.761,0,0,0,28.145,0",
    transform: "translate(-12.929 0)",
    fill: "#60ac50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4261",
    "data-name": "Path 4261",
    d: "M.762,27.786a.762.762,0,0,0-.531,1.307l3.96,3.968a.762.762,0,1,0,1.077-1.076l-3.96-3.967a.757.757,0,0,0-.546-.232",
    transform: "translate(0 -21.278)",
    fill: "#60ac50"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletion);
export default __webpack_public_path__ + "static/media/completion.170d5fee41cf1c1dcf60ec09d67a4c5c.svg";
export { ForwardRef as ReactComponent };